import { isPickupBy } from 'common/helpers/featureFlags';

const RombauerPickupBy = (props) => {
  const { cart } = props;
  if (!isPickupBy()) {
    return null;
  }
  return (
    <>
      {cart.metaData?.['pickup-by'] && (
        <>
          <br />
          <br />
          Pickup By: {cart.metaData['pickup-by']}
        </>
      )}
    </>
  );
};

export default RombauerPickupBy;
